import { render, staticRenderFns } from "./EducationDetail.vue?vue&type=template&id=6919651a&scoped=true"
import script from "./EducationDetail.vue?vue&type=script&lang=js"
export * from "./EducationDetail.vue?vue&type=script&lang=js"
import style0 from "./EducationDetail.vue?vue&type=style&index=0&id=6919651a&prod&lang=scss&scoped=true"
import style1 from "./EducationDetail.vue?vue&type=style&index=1&id=6919651a&prod&lang=scss"
import style2 from "./EducationDetail.vue?vue&type=style&index=2&id=6919651a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6919651a",
  null
  
)

export default component.exports